import React, { createRef, useRef } from 'react';
import { isMobile } from '../../utils/app.helper';

type Props = {
    id?: string;
    className?: string;
    children: React.ReactNode;
    innerRef?: React.RefObject<HTMLDivElement>;
    onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
}

const NoSpace: React.FC<Props> = ({ children, id, className = '' }): JSX.Element => {
    return <div className={`bv-nospace ${ className}  ${isMobile() ? ' bv-nospace--mobile' : ''}`} id={id}>{children}</div>;
};

const Content = React.forwardRef<HTMLDivElement, Props>(({ children, id, className = '', onClick }, ref) => {
    return <div onClick={onClick} className={`bv-nospace bv-content ${ className} ${isMobile() ? ' bv-content--mobile' : ''}`} ref={ref} id={id}>{children}</div>;
});
Content.displayName = 'Content';

const SubContent: React.FC<Props> = ({ children, id, className = '' }): JSX.Element => {
    return <div className={`bv-nospace bv-subcontent ${ className}  ${isMobile() ? ' bv-subcontent--mobile' : ''}`} id={id}>{children}</div>;
};

export const outerAspectRef = createRef<HTMLDivElement>();

const AspectContainer: React.FC<Props> = ({ children }): JSX.Element => {
    return <div className='bv-aspect-outer' ref={outerAspectRef}><div className={`bv-aspect-inner ${isMobile() ? ' bv-aspect-inner--mobile' : ''}`}>{children}</div></div>;
};

export * from './Sidebar/Sidebar';

export * from './Main/Main';

export {
    NoSpace,
    Content,
    SubContent,
    AspectContainer
};

